/* eslint-disable react-hooks/exhaustive-deps */
import Spinner from "components/common/Spinner";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isArray } from "lodash";

import VideoPlayerModal from "./VideoPlayerModal";
import ReactPlayer from "react-player";
import { getAllVideoGallery } from "services/videosGallary";
import { errorToast, getErrorObject, verifyObject } from "utilities/utils";
import { Link, useParams } from "react-router-dom";
import "./VideoReview.scss";

export default function VideosGrid({ isFromCustomer }) {
  //state
  const [state, setState] = useState({
    videosGallary: [],
    page: 1,
    show: false,
  });

  console.log(state,"---statestate")

  //dispatch
  const dispatch = useDispatch();
  const { videoGallery } = useSelector((state) => state.localStore);

  //navigate
  const { id } = useParams();

  const _getAllVideoGallery = async () => {
    try {
      await setState({ ...state, isLoading: true });
      let response = await getAllVideoGallery();
      console.log("response", response);
      setState({
        ...state,
        videosGallary: verifyObject(response, "data.data", []),
        isLoading: false,
      });
    } catch (e) {
      const { message } = getErrorObject(e);
      errorToast({
        content: message,
      });
      await setState({ ...state, isLoading: false });
    }
  };

  //use effects
  useEffect(() => {
    _getAllVideoGallery();
  }, []);

  const saveVideos = (d) => {
    dispatch({
      type: "ON_SET_VIDEO_DATA",
      payload: d.videoGallery,
    });
    // navigate(`/videos-gallary/${d.categoryId}`);
  };

  useEffect(() => {
    if (id && videoGallery) {
      let gallery = [];
      videoGallery.map((d) => {
        gallery = [
          ...gallery,
          {
            src: d.image ,
            caption: d.title,
            orginal: d.image,
          },
        ];
        // setVideos(gallery);
        return null;
      });
    }
  }, [videoGallery, id]);

  //on page change

  console.log("sssss", state.videosGallary);
  return (
    <>
      <div className="video-section">
        <div className="testimonial-list ">
          {state.isLoading && (
            <div className="center-flex">
              <Spinner size={70} />
            </div>
          )}
          {id && (
            <div className="row justify-content-start">
              {videoGallery.length > 0 &&
                videoGallery.map((v) => {
                  return <VideoPlayerModal d={v} />;
                })}
            </div>
          )}
          {/* {selectedVideo && <VideoPlayerModal d={selectedVideo} />} */}
          {!id && (
            <div className="row">
              {!state.isLoading &&
                state.videosGallary &&
                isArray(state.videosGallary) &&
                state.videosGallary
                  .slice(
                    0,
                    `${isFromCustomer ? 3 : state.videosGallary.length}`
                  )
                  .map((v) => {
                    return (
                      <Link
                        to={
                          isFromCustomer
                            ? `/video-gallery`
                            : `/video-gallery/${v.categoryName}`
                        }
                        onClick={() => saveVideos(v)}
                        className="col-lg-4 col-md-4 col-sm-6"
                      >
                        <div className="testimonials-item">
                          <div className="testimonial-img">
                            {/* <img
                          src={v.videoGallery[0].video}
                          alt=""
                          className="img-fluid"
                        /> */}
                            <ReactPlayer
                              url={v?.videoGallery[0]?.video == null ? v?.videoGallery[0]?.url : v?.videoGallery[0]?.video}
                              width="100%"
                            />
                            {/* <VideoPlayerModal d={v.videoGallery[0]} /> */}
                            <div className="bg-overlay">
                              <a
                                href="#"
                                className="play-icon"
                                title="Play Video"
                              >
                                <i className="fa-solid fa-play"></i>
                              </a>
                            </div>
                          </div>
                          <div className="testimonial-content">
                            <h4 className="font-weight-semibold text-default mb-xl-3 mb-2">
                              {v.categoryName}
                            </h4>
                          </div>
                        </div>
                      </Link>
                    );
                  })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
